import React from "react";
import { AddUserButton, UserIconWraper, UserButtonIcon } from "./UserManagement.elements";
import { PlusIcon } from "@/icons";

const AddNewUserButton = ({ onOpen }) => {
    return (
        <AddUserButton
            variant="outlined"
            onClick={onOpen}
            startIcon={
                <UserIconWraper>
                    <UserButtonIcon as={PlusIcon} />
                </UserIconWraper>
            }
        >
            Add User
        </AddUserButton>
    );
};

export default AddNewUserButton;
